module.exports = __webpack_public_path__ + "static/vodafone-52bd4325d04f5d40a364ffd05b38ee61.svg";